/*
创建者 魏强(2018.1.24)
走马灯
*/
<template>
  <div
    class="swipe-wrap"
    :style="style"
  >
    <div
      class="wrapper"
      id="swiper"
    >
      <div class="carousel-wrapper">
        <Carousel
          v-model="value"
          :autoplay="setting.autoplay"
          :autoplay-speed="setting.autoplaySpeed"
          :dots="setting.dots"
          :radius-dot="setting.radiusDot"
          :trigger="setting.trigger"
          :arrow="setting.arrow"
          @on-change="change"
          :height="520"
        >
          <CarouselItem
            v-for="item in data "
            :key="item.key"
          >
            <router-link
              :to="item.to"
              target="_blank"
            >
              <span
                class="img-box"
                :style="{backgroundImage:`url(${item.atturl})`}"
              ></span>
            </router-link>
          </CarouselItem>
        </Carousel>
      </div>
      <!--广告位-->
      <!-- <div class="banner-ads">
        <div class="banner-ads-img">
          <div class="ads-img-wrapper">
            <router-link to="recommend-goods?type=3" target="_blank">
              <img :src="pcXrsdGoodsAdv.advList[0].atturl" :alt="pcXrsdGoodsAdv.advList[0].aname">
            </router-link>
          </div>

          <div class="ads-img-wrapper">
            <router-link to="recommend-goods?type=4" target="_blank">
              <img :src="pcGwqjfStoreGoodsAdv.advList[0].atturl" :alt="pcGwqjfStoreGoodsAdv.advList[0].aname">
            </router-link>
          </div>
        </div>
      </div> -->
    </div>

  </div>
</template>
<script>
export default {
  props: ["data", "pcXrsdGoodsAdv", "pcGwqjfStoreGoodsAdv"],
  data() {
    let data = this.data;
    let bgcolor = !!data ? data[0].bgcolor : "#fff";
    return {
      value: 0,
      setting: {
        autoplay: true,
        autoplaySpeed: 3000,
        dots: "inside",
        radiusDot: true,
        trigger: "hover",
        arrow: "never",
        loop: true,
      },
      style: { backgroundColor: bgcolor },
    };
  },
  methods: {
    change(oldValue, value) {
      this.style = { backgroundColor: this.data[value].bgcolor };
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../assets/css/home-page/banner/carousel.less";
// #swiper {
//   width: 770px !important;
//   position: relative;
// }
// .carousel-wrapper {
//   width: 770px;
// }

// .banner-ads {
//   position: absolute;
//   top: 0;
//   right: 0;
//   height: 100%;
//   width: 220px;
//   .ads-img-wrapper {
//     height: 50%;
//     width: 100%;
//     a {
//       display: block;
//       height: 100%;
//       img {
//         height: 100%;
//       }
//     }
//   }
//   .banner-ads-img {
//     height: 100%;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: space-between;
//   }
// }

// .img-box {
//   display: inline-block;
//   height: 520px;
//   width: 100%;
//   background-repeat: no-repeat;
//   background-position: center center;
//   background-size: cover;
// }
</style>



// WEBPACK FOOTER //
// carousel.vue?746db014